import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class RelatoriosContratuaisService {
  private baseUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }

  getRelatorios(
    contractId:string,
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    filterText:string = '',
    filterData:any | null,
  ){
  let params = new HttpParams()
          .set('page', pageIndex?.toString() || '0')
          .set('size', pageSize)
          .set('sortField', sortProperty || '')
          .set('sortDirection', sortDirection || '')
          .set('nomeRelatorio', filterText || '')
          .set('nomeAreaFuncional', filterData?.value?.nomeAreaFuncional || '')
          .set('nomeTipoRelatorio', filterData?.value?.nomeTipoRelatorio || '')
          .set('itemContratual', filterData?.value?.itemContratual || '')
          .set('prazoInicio', filterData?.value?.prazoInicio || '')
          .set('prazoFim', filterData?.value?.prazoFim || '')
          .set('periodoReferenciaInicio', filterData?.value?.periodoReferenciaInicio || '')
          .set('periodoReferenciaFim', filterData?.value?.periodoReferenciaFim || '')
          .set('situacaoPrazo', filterData?.value?.situacaoPrazo || '')

    return this.http.get(
      this.baseUrl +
      `/v1/contratos/${contractId}/relatorios-contratuais`
      , { params }
    );
  }
  getRelatoriosAtestados(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    nomeNumeroContratoOuNomeRelatorio:any
  ){
  let params = new HttpParams()
          .set('page', pageIndex?.toString() || '0')
          .set('size', pageSize)
          .set('sortField', sortProperty || '')
          .set('sortDirection', sortDirection || '')
          .set('nomeNumeroContratoOuNomeRelatorio', nomeNumeroContratoOuNomeRelatorio || '')
    return this.http.get(
      this.baseUrl +
      `/v1/afericoes/relatorios-contratuais/relatorios-atestados`
      , { params }
    );
    
  }
  
  getRelatorioPorId(idRelatorio:any, idContract:any,){
      return this.http.get<any[]>(this.baseUrl + `/v1/contratos/${idContract}/relatorios-contratuais/${idRelatorio}`);
  }
  criarRelatorio(data:any, idContract:any){
        return this.http.post(this.baseUrl + `/v1/contratos/${idContract}/relatorios-contratuais`, data );
  }
  atualizarRelatorio(idRelatorio:any, idContract:any, dados:any){
    return this.http.put(this.baseUrl + `/v1/contratos/${idContract}/relatorios-contratuais/${idRelatorio}`, dados )
  }
    getNomeRelatorio(){
      return this.http.get<any[]>(this.baseUrl + `/v1/relatorios?page=0&size=10&sortField=nome&sortDirection=asc&nome=&descricao=`);
  }
    getTipoRelatorio(){
      return this.http.get<any[]>(this.baseUrl + `/v1/tipos-relatorios?page=0&size=10&sortField=nome&sortDirection=asc&nome=&descricao=`);
  }
    getAreasFuncionais(idTipoRelatorio?: any){
      let params = new HttpParams()
        .set('page', '0')
        .set('size', '10')
        .set('sortField', 'nome')
        .set('sortDirection', 'asc')
        .set('nome', '')
        .set('descricao', '');

      if(idTipoRelatorio){
        params = params.set('idTipoRelatorio', idTipoRelatorio);
      }

      return this.http.get<any[]>(this.baseUrl + `/v1/areas-funcionais`, { params });
  }
  deleteRelatorio(contractId: any, idRelatorio: any) {
    return this.http.delete(`${this.baseUrl}/v1/contratos/${contractId}/relatorios-contratuais/${idRelatorio}`,)
  }
  deleteRelatorioEmLote(contractId: any, idsRelatorio: any) {
    return this.http.post(`${this.baseUrl}/v1/contratos/${contractId}/relatorios-contratuais/excluir-em-lote`, idsRelatorio)
  }
  getHistorico(id: string | null, idContrato: any, pageIndex: number = 0) {
    return this.http.get(
      this.baseUrl +
        `/v1/contratos/${idContrato}/relatorios-contratuais/${id}/historico?page=${pageIndex}&size=10&sortField=data&sortDirection=desc`,
    );
  }
}
